import { render, staticRenderFns } from "./DispatchingResultsComDePerm.vue?vue&type=template&id=e563dada&scoped=true"
import script from "./DispatchingResultsComDePerm.vue?vue&type=script&lang=js"
export * from "./DispatchingResultsComDePerm.vue?vue&type=script&lang=js"
import style0 from "./DispatchingResultsComDePerm.vue?vue&type=style&index=0&id=e563dada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e563dada",
  null
  
)

export default component.exports